/* eslint-disable */
const titlesData = document.querySelectorAll(".GraphicsColumns-titleData");
const columnsData = document.getElementsByClassName("GraphicsColumns-column");

Array.from(titlesData).forEach((titleData, index) => {
  columnsData[index].style.height = Math.ceil((Number(titleData.textContent)*2.5))+"px";

  const colorElement = titleData.querySelector("mark");

  const color = colorElement ? window.getComputedStyle( colorElement ,null).getPropertyValue('color') : "red";

  columnsData[index].style.backgroundColor = color;
});